import { render, staticRenderFns } from "./ot-settings-layout.vue?vue&type=template&id=e3c13c18&scoped=true&"
import script from "./ot-settings-layout.vue?vue&type=script&lang=ts&"
export * from "./ot-settings-layout.vue?vue&type=script&lang=ts&"
import style0 from "./ot-settings-layout.vue?vue&type=style&index=0&id=e3c13c18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3c13c18",
  null
  
)

export default component.exports